import { connect } from 'react-redux';

import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { contentCountsUpToDate } from '~src/spacesPlatform/actions/ContentCountsActions';
import { addContentFavorite, removeContentFavorite } from '~src/spacesPlatform/actions/FavoritesActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { PublishedConnectionSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { enterPublishedConnectionSubspace } from '../actions/EnterPublishedConnectionSubspaceAction';
import { publishedConnectionCountsRequest } from '../actions/PublishedConnectionCountsRequestAction';
import {
  PublishedConnectionSpace,
  PublishedConnectionSpaceDispatchProps,
  PublishedConnectionSpaceOwnProps,
  PublishedConnectionSpaceStateProps,
} from './PublishedConnectionSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionSpaceStateProps> = (state) => ({
  contentCountsPublishedConnection: selectContentCounts<'virtualConnection'>(state, 'virtualConnection'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isServerOrSiteAdmin: CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionSpaceDispatchProps, PublishedConnectionSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionSubspace(
      ownProps.publishedConnectionDetailInfo,
      ownProps.subplaceName as PublishedConnectionSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionCountsRequest('virtualConnection'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
});

export const ConnectedPublishedConnectionSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionSpace);
